import { APIService } from "./api";
import { API } from "@/lib/api";
import { ReadStoreFormat, WriteStoreFormat } from "@/types/storeFormat";

export const StoreFormatsService = new APIService<
  ReadStoreFormat,
  WriteStoreFormat
>(API.StoreFormats);
export const fetchStoreFormatList = StoreFormatsService.getList;
export const fetchStoreFormat = StoreFormatsService.get;
export const createStoreStoreFormat = StoreFormatsService.post;
export const updateStoreFormat = StoreFormatsService.patch;
